import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'EmbeddedImage' })(
  ({ breakpoints, spacing, brandColors }) => ({
    grid: {
      justifyContent: 'center',
    },
    imageWrapper: {
      [breakpoints.up('md')]: {
        maxWidth: '84%',
      },
    },
    image: {
      width: '100%',
      maxWidth: '100%',
      borderRadius: spacing(-1),
    },
    mobileImage: {
      [breakpoints.up('md')]: {
        display: 'none',
      },
    },
    hiddenOnMobile: {
      display: 'none',
      [breakpoints.up('md')]: {
        display: 'initial',
      },
    },
    caption: {
      whiteSpace: 'pre-wrap',
      color: brandColors.tintsNeutral20,
      marginTop: spacing(1),
    },
    container: {
      [breakpoints.up('md')]: {
        padding: `0 ${spacing(5)}}`,
      },
    },
  })
);

export default useStyles;
